// extracted by mini-css-extract-plugin
module.exports = {"notification":"notification-1P6m8","notificationGlobal":"notificationGlobal-1OeQf","action":"action-2ilki","done":"done-3Mu3N"};